export const MENU_RIGHT = [
  {
    name: '技术参数',
    type: 1,
    isClick: true,
    code: 'techParam'
  },
  {
    name: '成本参数',
    type: 2,
    isClick: false,
    code: 'costParam'
  },
  {
    name: '装配数据',
    type: 3,
    isClick: false,
    code: 'assembleParam'
  },
  {
    name: '电气效率',
    type: 4,
    isClick: false,
    code: 'efficiencyParam'
  }
];

export const MENU_RIGHT_Effect = [
  {
    name: '功率-推力-Cp曲线',
    type: 5,
    isClick: true
  },
  {
    name: 'Cp-λ曲线',
    type: 6,
    isClick: false
  },
  {
    name: '功率曲线转换',
    type: 7,
    isClick: false
  }
];

export const POWER_CURVE = [
  {
    name: '功率',
    type: 8,
    isClick: true
  },
  {
    name: '推力',
    type: 9,
    isClick: false
  },
  {
    name: 'cp曲线',
    type: 10,
    isClick: false
  }
];
